import { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectAuthUserId } from "../../auth/AuthSlice";
import subjectPlanAPI from "../../../api/subjectPlanAPI";

export const useSharedSubjectPlans = () => {
  const userId = useSelector(selectAuthUserId);
  const query = useQuery(["plans", "shared"], subjectPlanAPI.fetchPlans);

  return {
    ...query,
    data: useMemo(
      () => query.data?.filter((item) => item.userId !== userId),
      [query.data, userId]
    ),
  };
};
